export { useGetCollectionTitle } from './useGetCollectionTitle';
